// extracted by mini-css-extract-plugin
export var container = "_g4-1";
export var cornerButtonContainer = "_g4-6";
export var disabled = "_g4-2";
export var dragActive = "_g4-3";
export var fileContainer = "_g4-5";
export var hiddenInput = "_g4-4";
export var widthContainer = "_g4-0";